import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 0, // Always fetch fresh data (no cache staleness)
      gcTime: 1000 * 60 * 5, // Keep unused data in cache for 5 minutes before garbage collection
    },
  },
});
